var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.93 63.75"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.88 38.53v25.22H25V38.53H0V25.05h25V0h13.88v25.05h25v13.48z"
  })));
}
export default SvgPlus;